import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import { SemanticScore } from "@app/common/utils";

import Stack, { StackProps } from "@rui/Stack";

const CHIP_PROPS_BY_SEMANTIC_SCORE: {
  [key in SemanticScore]: {
    label: string;
    color: React.CSSProperties["color"];
    bgcolor: React.CSSProperties["backgroundColor"];
  };
} = {
  positive: {
    label: "good",
    color: "shades.meadow.500",
    bgcolor: "shades.meadow.50",
  },
  neutral: {
    label: "okay",
    color: "shades.orange.500",
    bgcolor: "shades.orange.50",
  },
  negative: {
    label: "poor",
    color: "shades.negative.500",
    bgcolor: "shades.negative.50",
  },
  unknown: {
    label: "-",
    color: "shades.neutral.500",
    bgcolor: "shades.neutral.50",
  },
};

const StyledChip = styled((props: StackProps) => (
  <Stack variant="center" {...props} />
))(() => ({
  textTransform: "uppercase",
  borderRadius: "4px",
  padding: "1px 4px",
  height: "18px",
  width: "fit-content",
}));

const SemanticScoreChip = ({ type }: { type: SemanticScore }) => {
  const { label, ...sx } = CHIP_PROPS_BY_SEMANTIC_SCORE[type];
  return (
    <StyledChip sx={sx}>
      <Typography variant="labelMed">{label}</Typography>
    </StyledChip>
  );
};

export default SemanticScoreChip;
